import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";
import { CONTACT } from "@/data/site";

export const Footer = () => {
  const { t, lang } = useI18n();
  return (
    <footer data-testid="site-footer" className="bg-[#1D3557] text-white/85 mt-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img src="/assets/682gladr_logo.png" alt="I Lake It Bellagio" className="h-12 w-12 object-contain" style={{filter:"brightness(0) invert(1)"}} />
            <div className="font-brand text-base tracking-[0.14em] uppercase font-extrabold">I LAKE IT <span className="font-medium">BELLAGIO</span></div>
          </div>
          <p className="text-sm text-white/60 max-w-xs leading-relaxed">{t("footer.tagline")}</p>
        </div>
        <div>
          <h4 className="font-display text-lg mb-4 text-white">{t("footer.quickLinks")}</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to={`/${lang}`} className="hover:text-[#6FA8C7] transition-colors">{t("nav.home")}</Link></li>
            <li><Link to={`/${lang}/bellagio`} className="hover:text-[#6FA8C7] transition-colors">{t("nav.bellagio")}</Link></li>
            <li><Link to={`/${lang}/camere`} className="hover:text-[#6FA8C7] transition-colors">{t("nav.rooms")}</Link></li>
            <li><Link to={`/${lang}/chi-siamo`} className="hover:text-[#6FA8C7] transition-colors">{t("nav.about")}</Link></li>
            <li><Link to={`/${lang}/servizi-trasporti`} className="hover:text-[#6FA8C7] transition-colors">{t("nav.services")}</Link></li>
            <li><Link to={`/${lang}/faq`} className="hover:text-[#6FA8C7] transition-colors">FAQ</Link></li>
            <li><Link to={`/${lang}/prenota`} className="hover:text-[#6FA8C7] transition-colors">{t("nav.bookNow")}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display text-lg mb-4 text-white">{t("footer.contacts")}</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0 text-[#6FA8C7]" />
              <span>{t("footer.address")}</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone className="w-4 h-4 flex-shrink-0 text-[#6FA8C7]" />
              <a data-testid="footer-phone" href={`tel:${CONTACT.phone}`} className="hover:text-[#6FA8C7]">{CONTACT.phoneDisplay}</a>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="w-4 h-4 flex-shrink-0 text-[#6FA8C7]" />
              <a data-testid="footer-email" href={`mailto:${CONTACT.email}`} className="hover:text-[#6FA8C7] break-all">{CONTACT.email}</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 text-xs text-white/50 flex flex-col md:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} I Lake It Bellagio. {t("footer.rights")}</span>
          <span data-testid="footer-codes">CIR: {CONTACT.cir} · CIN: {CONTACT.cin}</span>
          <Link to={`/${lang}/privacy`} data-testid="footer-privacy" className="hover:text-[#6FA8C7] transition-colors">{t("footer.privacy")}</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
